import type { AuthUser } from "../features/auth/types";

/** SCIM/provision CSV template: super = full catalog; owner = managed stores only. */
export function provisionTemplateForRole(role: AuthUser["role"] | undefined): {
  apiPath: string;
  filename: string;
} {
  if (role === "superuser") {
    return { apiPath: "/provision/templates/super", filename: "provision-template-super.csv" };
  }
  return { apiPath: "/provision/templates/owner", filename: "provision-template-owner.csv" };
}
